<script setup lang="ts">
import type { DeviceModel } from '@/types/models/DeviceModel'
import { StackLayout, TypographyItem, TypographyWithPrefix } from '@rfc/rfc-components-library'

type Props = {
    data?: DeviceModel
}
defineProps<Props>()
</script>

<template>
    <StackLayout direction="column">
        <TypographyWithPrefix
            v-if="data?.event"
            :prefix="$t('device.cardContent.eventAssociatedTitle')"
            :label="data?.event?.name ?? ''"
            boldLabel
            class="prefix-wrapped" />
        <TypographyItem v-else :label="$t('device.cardContent.noEventAssociated')" />
        <TypographyWithPrefix
            v-if="data?.checkpoint"
            :prefix="$t('device.cardContent.checkpointAssociatedTitle')"
            :label="data?.checkpoint?.name ?? ''"
            boldLabel
            class="prefix-wrapped" />
        <TypographyItem v-else :label="$t('device.cardContent.noCheckpointAssociated')" />
    </StackLayout>
</template>
